import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import { setIsMobile } from "@/slices/sidebarSlice";
import { AppDispatch } from "@/redux/store";

const ResponsiveHandler: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    // Define the media query for mobile
    const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

    // Update the Redux store whenever the screen size changes
    useEffect(() => {
        dispatch(setIsMobile(isMobile));
    }, [isMobile, dispatch]);

    return null; // This component doesn't render anything
};

export default ResponsiveHandler;
